export interface BacklinkOpportunity {
  id: string;
  name: string;
  type: 'blog' | 'directory' | 'press' | 'review' | 'local' | 'social';
  url: string;
  language: 'fr' | 'en' | 'es' | 'pt';
  metrics: {
    da: number;
    dr: number;
    traffic: number;
    relevance: number;
    backlinksCount?: number;
  };
  contact: {
    angle: string;
    method: string;
    email?: string;
    social?: string;
  };
  status: 'to_contact' | 'contacted' | 'negotiating' | 'secured' | 'live';
  cost?: {
    amount: number;
    currency: string;
    type: 'one_time' | 'monthly' | 'yearly';
  };
  notes?: string;
}

export interface ReputationItem {
  id: string;
  platform: string;
  type: 'review' | 'post' | 'mention';
  url: string;
  status: 'to_do' | 'in_progress' | 'done';
  priority: 'high' | 'medium' | 'low';
  impact: number;
  notes?: string;
}

export interface BacklinkStats {
  total: number;
  follow: number;
  nofollow: number;
  referringDomains: number;
  referringIPs: number;
  topAnchors: {
    anchor: string;
    percentage: number;
    count: number;
  }[];
}

// Statistiques backlinks réelles (depuis SEMrush)
export const backlinkStats39V: BacklinkStats = {
  total: 1600,
  follow: 384, // 23.97%
  nofollow: 1216, // 76.03%
  referringDomains: 476,
  referringIPs: 484,
  topAnchors: [
    { anchor: 'www.le39v.com', percentage: 9, count: 146 },
    { anchor: 'le 39v', percentage: 9, count: 140 },
    { anchor: 'le39v.com', percentage: 7, count: 113 },
    { anchor: 'le39v', percentage: 7, count: 108 },
    { anchor: 'le39v.eu', percentage: 4, count: 69 }
  ]
};

// Opportunités de backlinks basées sur les backlinks existants
export const backlinkOpportunities39V: BacklinkOpportunity[] = [
  // Backlinks existants transformés en opportunités
  {
    id: 'backlink_39v_fr_1',
    name: 'Michelin Guide',
    type: 'directory',
    url: 'https://guide.michelin.com',
    language: 'fr',
    metrics: {
      da: 92,
      dr: 88,
      traffic: 1500000,
      relevance: 98,
      backlinksCount: 40
    },
    contact: {
      angle: 'Mise à jour de la fiche restaurant',
      method: 'email',
      email: 'contact@michelin.com'
    },
    status: 'live',
    notes: 'Backlink de haute qualité déjà actif'
  },
  {
    id: 'backlink_39v_fr_2',
    name: 'Sortiraparis',
    type: 'blog',
    url: 'https://sortiraparis.com',
    language: 'fr',
    metrics: {
      da: 72,
      dr: 68,
      traffic: 850000,
      relevance: 95,
      backlinksCount: 63
    },
    contact: {
      angle: 'Article sur les meilleurs restaurants parisiens',
      method: 'email',
      email: 'redaction@sortiraparis.com'
    },
    status: 'live',
    notes: '63 backlinks actifs'
  },
  {
    id: 'backlink_39v_fr_3',
    name: 'Forbes France',
    type: 'press',
    url: 'https://forbes.fr',
    language: 'fr',
    metrics: {
      da: 88,
      dr: 85,
      traffic: 2500000,
      relevance: 92,
      backlinksCount: 1
    },
    contact: {
      angle: 'Feature pour Saint-Valentin',
      method: 'email',
      email: 'redaction@forbes.fr'
    },
    status: 'live',
    notes: 'Article déjà publié sur la Saint-Valentin'
  },
  {
    id: 'backlink_39v_fr_4',
    name: 'TripAdvisor France',
    type: 'review',
    url: 'https://tripadvisor.fr',
    language: 'fr',
    metrics: {
      da: 95,
      dr: 92,
      traffic: 8500000,
      relevance: 100,
      backlinksCount: 20
    },
    contact: {
      angle: 'Optimisation de la fiche et réponses aux avis',
      method: 'email'
    },
    status: 'live',
    notes: 'Profil actif avec 20 backlinks'
  },
  {
    id: 'backlink_39v_fr_5',
    name: 'Secret Box',
    type: 'local',
    url: 'https://le39v.secretbox.fr',
    language: 'fr',
    metrics: {
      da: 55,
      dr: 52,
      traffic: 45000,
      relevance: 88,
      backlinksCount: 132
    },
    contact: {
      angle: 'Coffrets cadeaux gastronomiques',
      method: 'email'
    },
    status: 'live',
    notes: '132 backlinks via la plateforme de coffrets'
  },
  // Nouvelles opportunités à développer
  {
    id: 'backlink_39v_en_1',
    name: 'Luxury Travel Magazine',
    type: 'press',
    url: 'https://luxurytravelmagazine.com',
    language: 'en',
    metrics: {
      da: 68,
      dr: 72,
      traffic: 320000,
      relevance: 85
    },
    contact: {
      angle: 'Feature about Paris fine dining with Eiffel Tower views',
      method: 'email',
      email: 'editor@luxurytravelmagazine.com'
    },
    status: 'to_contact'
  },
  {
    id: 'backlink_39v_en_2',
    name: 'The Infatuation Paris',
    type: 'blog',
    url: 'https://theinfatuation.com/paris',
    language: 'en',
    metrics: {
      da: 75,
      dr: 78,
      traffic: 1250000,
      relevance: 92
    },
    contact: {
      angle: 'Best romantic restaurants in Paris guide',
      method: 'email',
      email: 'paris@theinfatuation.com'
    },
    status: 'to_contact'
  }
];

// Checklist e-réputation pour Le 39V
export const reputationChecklist39V: ReputationItem[] = [
  {
    id: 'rep_39v_1',
    platform: 'Google My Business',
    type: 'post',
    url: 'https://business.google.com/posts',
    status: 'in_progress',
    priority: 'high',
    impact: 90,
    notes: 'Publier 2 posts par semaine'
  },
  {
    id: 'rep_39v_2',
    platform: 'TripAdvisor',
    type: 'review',
    url: 'https://tripadvisor.fr/le39v',
    status: 'done',
    priority: 'high',
    impact: 85,
    notes: '20 backlinks actifs - Continuer les réponses aux avis'
  },
  {
    id: 'rep_39v_3',
    platform: 'Michelin Guide',
    type: 'mention',
    url: 'https://guide.michelin.com/fr/fr/ile-de-france/paris/restaurant/le-39v',
    status: 'done',
    priority: 'high',
    impact: 95,
    notes: '40 backlinks actifs - Fiche à jour'
  },
  {
    id: 'rep_39v_4',
    platform: 'Forbes France',
    type: 'mention',
    url: 'https://forbes.fr',
    status: 'done',
    priority: 'medium',
    impact: 80,
    notes: 'Article Saint-Valentin publié'
  }
];

export const backlinkStatsCafeMax: BacklinkStats = {
  total: 0,
  follow: 0,
  nofollow: 0,
  referringDomains: 0,
  referringIPs: 0,
  topAnchors: []
};

export const backlinkOpportunitiesCafeMax: BacklinkOpportunity[] = [];

export const reputationChecklistCafeMax: ReputationItem[] = [
  {
    id: 'rep_pending',
    platform: 'Analyse en cours',
    type: 'post',
    url: '',
    status: 'to_do',
    priority: 'high',
    impact: 0,
    notes: 'Analyse en cours de réalisation'
  }
];

export const getBacklinkOpportunities = (restaurantId: string): BacklinkOpportunity[] => {
  return restaurantId === '39v' ? backlinkOpportunities39V : backlinkOpportunitiesCafeMax;
};

export const getReputationChecklist = (restaurantId: string): ReputationItem[] => {
  return restaurantId === '39v' ? reputationChecklist39V : reputationChecklistCafeMax;
};

export const getBacklinkStats = (restaurantId: string): BacklinkStats => {
  return restaurantId === '39v' ? backlinkStats39V : backlinkStatsCafeMax;
};

export const getBacklinksByLanguage = (restaurantId: string, language: 'fr' | 'en' | 'es' | 'pt'): BacklinkOpportunity[] => {
  const allOpportunities = getBacklinkOpportunities(restaurantId);
  return allOpportunities.filter(opp => opp.language === language);
};

export const getBacklinkMetrics = (restaurantId: string) => {
  const allOpportunities = getBacklinkOpportunities(restaurantId);
  const stats = getBacklinkStats(restaurantId);
  const checklist = getReputationChecklist(restaurantId);
  
  return {
    totalOpportunities: allOpportunities.length,
    byStatus: {
      to_contact: allOpportunities.filter(o => o.status === 'to_contact').length,
      contacted: allOpportunities.filter(o => o.status === 'contacted').length,
      negotiating: allOpportunities.filter(o => o.status === 'negotiating').length,
      secured: allOpportunities.filter(o => o.status === 'secured').length,
      live: allOpportunities.filter(o => o.status === 'live').length
    },
    byLanguage: {
      fr: allOpportunities.filter(o => o.language === 'fr').length,
      en: allOpportunities.filter(o => o.language === 'en').length,
      es: allOpportunities.filter(o => o.language === 'es').length,
      pt: allOpportunities.filter(o => o.language === 'pt').length
    },
    averageMetrics: {
      da: Math.round(allOpportunities.reduce((sum, o) => sum + o.metrics.da, 0) / allOpportunities.length),
      dr: Math.round(allOpportunities.reduce((sum, o) => sum + o.metrics.dr, 0) / allOpportunities.length),
      relevance: Math.round(allOpportunities.reduce((sum, o) => sum + o.metrics.relevance, 0) / allOpportunities.length)
    },
    stats: {
      total: stats.total,
      follow: stats.follow,
      nofollow: stats.nofollow,
      referringDomains: stats.referringDomains,
      referringIPs: stats.referringIPs,
      topAnchors: stats.topAnchors
    },
    reputation: {
      total: checklist.length,
      completed: checklist.filter(item => item.status === 'done').length,
      inProgress: checklist.filter(item => item.status === 'in_progress').length,
      todo: checklist.filter(item => item.status === 'to_do').length
    }
  };
};